<template>
  <p>
    <template
      v-for="(cont, index) in content"
    >
      <!-- TEXT ENTRIES -->
      <template v-if="cont.type === 'text'">
        <template v-if="cont.marks">
          <StyledContent :key="index" :content="cont" />
        </template>
        <template v-else>{{ cont.text }}</template>
      </template> <!-- END TEXT ENTRIES -->
      <!-- CUSTOM IMAGE -->
      <template v-else-if="cont.type === 'custom_image' || cont.type === 'image'">
        <img
          :key="index"
          :src="cont.attrs.src"
          class="image"
          alt="Image"
        />
      </template> <!-- END CUSTOM IMAGE -->
      <template v-else-if="cont.type === 'hard_break'|| cont.type === 'hardBreak'">
        <br :key="index"/>
      </template>

    </template>
  </p>
</template>

<script>

import StyledContent from '@/components/post/Blocks/StyledContent.vue'

export default {
  name: 'Paragraph',
  props: ['content'],
  components: {
    StyledContent
  }
}
</script>
